import { render, staticRenderFns } from "./CampanhasList.vue?vue&type=template&id=48b47226"
import script from "./CampanhasList.vue?vue&type=script&lang=js"
export * from "./CampanhasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports